module.exports = __webpack_public_path__ + "img/Serpens.8a11c2ff.png";